module.exports = __webpack_public_path__ + "img/0b37631.webp";